import { getBrandName } from '@/util/enterprise'
import ChatTurnProgress from '@/chat-common/components/message-bubbles/ChatTurnProgress'

type ChatLoadingBubbleProps = {
  conversationId: string
}

export default function ChatLoadingBubble(props: ChatLoadingBubbleProps) {
  const { conversationId } = props

  // Message header
  const messageHeader = getBrandName()

  return (
    <div className="rounded-lg whitespace-pre-wrap bg-white transition ease-in-out py-2 px-4">
      <p className={`font-bold text-xl mb-1`}>{messageHeader}</p>
      <ChatTurnProgress conversationId={conversationId} />
    </div>
  )
}
